<template>
  <div
    id="app"
    :class="
      (isContrast ? 'contrast' : '') +
      (isMobile ? ' mobile' : '') +
      (' fontsize-' + baseFontSize)
    "
  >
    <loading
      v-if="!isContrast"
      :active.sync="loading"
      :can-cancel="true"
      :color="colorLoader"
      :is-full-page="true"
    ></loading>
    <router-view :key="key" />
    <label for="g-recaptcha-response" style="display: none"></label>
  </div>
</template>

<style src="@/vendor/styles/bootstrap.scss" lang="scss"></style>
<style src="@/vendor/styles/appwork.scss" lang="scss"></style>
<style src="@/vendor/styles/theme-sunrise.scss" lang="scss"></style>
<style src="@/vendor/styles/colors.scss" lang="scss"></style>
<style src="@/vendor/styles/uikit.scss" lang="scss"></style>
<style src="./style.scss" lang="scss"></style>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  name: "app",
  metaInfo: {
    title: "Index",
    titleTemplate: "Rezerwacje internetowe - %s",
  },
  components: {
    Loading,
  },
  data() {
    return {
      colorLoader: "#be1b53",
      currentCompanyName: "",
    };
  },
  computed: {
    loading() {
      return this.$store.getters.loading;
    },
    contrast() {
      return this.$store.getters.getContrast;
    },
    isContrast() {
      return this.contrast != "none";
    },
    baseFontSize() {
      return this.$store.getters.getBaseFontSize;
    },
    key: function () {
      return this.$store.getters.getKey;
    },
    isMobile() {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        return true;
      } else {
        return false;
      }
    },
  },
  updated() {
    // Remove loading state
    setTimeout(() => document.body.classList.remove("app-loading"), 1);
    const companyName = this.$store.getters.getCompanyName;
    if (!companyName) {
      return;
    }

    if (this.currentCompanyName == companyName) {
      return;
    }

    this.currentCompanyName = companyName;

    this.$store.dispatch("updateLocales", companyName);
  },
  mounted() {
    console.log(this.$store.getters.getCompanyName);
  },
};
</script>
